export default __webpack_public_path__ + "static/media/Cattura9.2f16a243.jpg";